import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('model.dictionary.ProjectStatusDictionary')
export class ProjectStatus extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'title')
    title?: string;

  @JsonProperty(String, 'shortTitle')
  shortTitle?: string;

    @JsonProperty(Number, 'pos')
    pos?: number;

    @JsonProperty(Boolean, 'active')
    active?: boolean;

    @JsonProperty(String, 'clazz')
    clazz?: string;

    @JsonProperty(String, 'color')
    color?: string;
}
